
































































































































































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ReportModule from '@/store/modules/Report';
import AuthModule from '@/store/modules/Auth';
import GameModule from '@/store/modules/Game';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import MemberBody from '@/components/Table/MemberBody.vue';
import LogBody from '@/components/Table/LogBody.vue';
import Pagination from '@/components/Pagination.vue';
import WinLoseData from '@/data/WinLoseData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import ProductDropdown from '@/components/ProductDropdown.vue';
import { ICriteria, FetchType } from '@/interface/Report';
import DateRangeLogBody from '@/components/Table/DateRangeLog.vue';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    MemberBody,
    LogBody,
    ProductDropdown,
    DateRangeLogBody,
  },
})
export default class WinLoseMemberView extends Mixins(
  ToolMixin, ErrorHandleMixin, PaginationMixin,
) {
  ReportInstance = getModule(ReportModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  GameInstance = getModule(GameModule, this.$store);

  componentKey = 0;

  sortList = [
    'turnover',
    'agent',
  ];

  Criteria: ICriteria = {
    ...this.Period,
    generic: true,
    isSearch: false,
    limit: 100,
    page: 1,
    products: 'TOTAL',
    categories: 'TOTAL',
    gameName: 'TOTAL',
    role: this.AuthInstance.user.role,
    userId: this.AuthInstance.user._id,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
    sort: 'turnover',
    isElastic: true,
    fetchType: FetchType.new,
    isNewModel: false,
    isOutstanding: false,
    isComposite: true,
  };

  dropdownCriteria = {
    products: {
      type: 'Products',
      componentKeys: 0,
      productsList: [],
      selected: '',
    },
    categories: {
      type: 'Categories',
      componentKeys: 0,
      selected: '',
    },
    games: {
      type: 'Games',
      componentKeys: 0,
      selected: '',
      gamesList: [],
      sortList: [],
    },
  }

  isShow = {
    category: false,
    game: false,
  }

  GameList: any = {};

  BreadcrumbList: any = [];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  betTransactionType = 'Total'

  failResult = false;

  productTotal = 'TOTAL'

  type = '';

  WinLoseList: any = {};

  resultData: any = {};

  dataList: any = [];

  LoginName = '';

  TableHeadMember = [...WinLoseData.TableHeadMember];

  FilteredTableHeadMember: Array<object> = [...WinLoseData.TableHeadMember];

  TableHeadLog: any = [];

  mode = 'agent';

  dataKey = 'users';

  isMember = false;

  detailFooterCol = 0;

  totalLog = 0;

  summaryLog = 0;

  houseEdge = 0;

  startdate = '';

  enddate = '';

  currentDuration = 'Today';

  isRangeDate = false;

  durationTime = '';

  isSuperadmin = false;

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchperiod() {
    const datestart = this.$moment(this.Period.start.date).format('L');
    this.startdate = this.$moment(datestart).format('DD-MM-YYYY');
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchperiod2() {
    const dateend = this.$moment(this.Period.end.date).format('L');
    this.enddate = this.$moment(dateend).format('DD-MM-YYYY');
  }

  created() {
    this.isSuperadmin = ['SUPERADMIN'].includes(this.AuthInstance.user.role);
    this.fetchWinLose();
    this.fetchGame();
  }

  initial() {
    this.currentTool = 'Today';
    this.Period = {
      start: {
        date: this.$moment().startOf('day').toDate(),
      },
      end: {
        date: this.$moment().endOf('day').toDate(),
      },
    };
    this.Criteria = {
      ...this.Period,
      generic: true,
      isSearch: false,
      limit: 100,
      page: 1,
      products: 'TOTAL',
      categories: 'TOTAL',
      gameName: 'TOTAL',
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      sort: 'turnover',
      isElastic: true,
      fetchType: FetchType.new,
      isNewModel: false,
      isOutstanding: false,
      isComposite: true,
    };
    this.LoginName = '';
    this.isMember = false;
  }

  selectSort(item) {
    if (this.Criteria.sort === item) return false;
    this.Criteria.sort = item;
    this.fetchWinLose();
  }

  handleToggleCompositeElk(isComposite: boolean) {
    this.Criteria.isComposite = isComposite;
    this.fetchWinLose(true);
  }

  async handleFilterOutstanding(isOutstanding: boolean, key: string) {
    this.Criteria.isOutstanding = isOutstanding;
    this.betTransactionType = key;
    await this.fetchWinLose();
  }

  handleProductDropdown(item, type) {
    if (type === 'Products') this.dropdownCriteria.products.selected = item.provider.toUpperCase();
    if (type === 'Games') this.dropdownCriteria.games.selected = item.game;
    else this.dropdownCriteria[type.toLowerCase()].selected = item.value.toUpperCase();
    if (type === 'Products') {
      this.isShow.category = true;
      if (item.value === 'total') {
        this.isShow.category = false;
        this.isShow.game = false;
        this.dropdownCriteria.categories.selected = '';
        this.dropdownCriteria.games.selected = '';
      } else {
        this.dropdownCriteria.games.sortList = this.dropdownCriteria.games.gamesList
          .filter((v: any) => v.partner === item.value);
      }
      this.isShow.game = false;
      this.dropdownCriteria.categories.selected = 'TOTAL';
      this.Criteria.products = item.value.toUpperCase();
      this.Criteria.categories = 'TOTAL';
      this.Criteria.gameName = 'TOTAL';
    }
    if (type === 'Categories') {
      this.Criteria.categories = item.value;
      this.isShow.game = true;
      if (item.value === 'total') {
        this.isShow.game = false;
      } else {
        this.dropdownCriteria.games.sortList = this.dropdownCriteria.games.gamesList
          .filter((v: any) => v.partner.toUpperCase() === (this.dropdownCriteria.products.selected === 'ASKMEBET' ? 'DS' : this.dropdownCriteria.products.selected)
            && v.type === item.value)
          .sort((a: any, b: any) => a.game.localeCompare(b.game));
      }
      this.dropdownCriteria.games.selected = '';
      this.Criteria.gameName = 'TOTAL';
    }
    if (type === 'Games') this.Criteria.gameName = item.name;
    this.dropdownCriteria[type.toLowerCase()].componentKeys += 1;
    this.fetchWinLose();
    if (this.dropdownCriteria.products.selected === 'DS') this.dropdownCriteria.products.selected = 'ASKMEBET';
  }

  changePage(i: number) {
    this.PaginationDetail.current = i;
    this.Criteria.page = i;
    this.calPagination({ ...this.paginationParams });
    this.fetchWinLose();
  }

  async fetchWinLose(isPressFromBreadcrumn = false) {
    if (this.currentTool !== this.currentDuration) {
      this.PaginationDetail.current = 1;
      this.Criteria.page = 1;
      this.currentDuration = this.currentTool;
    }
    this.Criteria.isSearch = !!this.LoginName;
    this.Criteria.products = this.Criteria.products === 'ASKMEBET' ? 'DS' : this.Criteria.products;

    if (isPressFromBreadcrumn) {
      this.Criteria.isSearch = true;
      this.isMember = false;
    }

    // const startDate = this.$moment(this.Period.start.date).format('YYYYMMDD');
    // const endDate = this.$moment(this.Period.end.date).format('YYYYMMDD');
    // const DATE_FOR_FETCH_BET_TRANS_WITH_MONGO = ['20220210', '20220211'];

    // let stageForFetchBetTrans = 'both';
    // if (
    //   DATE_FOR_FETCH_BET_TRANS_WITH_MONGO.includes(startDate)
    //   && DATE_FOR_FETCH_BET_TRANS_WITH_MONGO.includes(endDate)
    // ) {
    //   stageForFetchBetTrans = 'mongo';
    // }

    // if (
    //   !DATE_FOR_FETCH_BET_TRANS_WITH_MONGO.includes(startDate)
    //   && !DATE_FOR_FETCH_BET_TRANS_WITH_MONGO.includes(endDate)
    // ) {
    //   stageForFetchBetTrans = 'elastic';
    // }

    // if (stageForFetchBetTrans === 'both' && this.isMember) {
    //   this.GeneralInstance.ShowAlert({
    //     isAlert: true,
    //     alertMsg: 'เรียนผู้ใช้บริการ เนื่องจากรายการเล่นในวันที่ 10 และ 11เกิดปัญหาขัดข้อง ทำให้
    // ไม่สามารถดูข้อมูลรายการเล่นแบบช่วงเวลาได้รบกวนตรวจสอบรายการเล่นแบบรายวันแทน
    // ขออภัยในความไม่สะดวก',
    //     alertColor: 'danger',
    //   });
    // }

    const criteria = { ...this.Criteria, ...this.Period };
    let res;
    this.GeneralInstance.toggleLoading(true);
    // if (this.isMember && !this.durationTime && stageForFetchBetTrans === 'elastic') {
    if (this.isMember && !this.durationTime) {
      criteria.isElastic = true;
      if (this.$moment(this.Period.start.date).format('YYYYMMDD') < 20210513) {
        this.Criteria.isElastic = false;
        criteria.isElastic = false;
      }
      res = await this.ReportInstance.FetchWinLoseRangeLog(criteria);
      if (res.code) {
        this.checkError(res);
        return false;
      }
      if (typeof res === 'object' && res.users) {
        this.resultData = res;
        this.isRangeDate = false;
        this.GeneralInstance.toggleLoading(false);
        if (['SUPERADMIN', 'ADMIN'].includes(this.AuthInstance.user.role)) {
          this.TableHeadLog = [...WinLoseData.TableHeadDateRange];
        } else {
          const filterOutstandingOut = WinLoseData.TableHeadDateRange[0]
            .filter((header: any) => header.displayName !== 'Outstanding');
          this.TableHeadLog = [filterOutstandingOut];
        }
        this.type = this.isMember ? 'dataWinLoseLog' : 'dataWinLose';
        this.mode = this.isMember ? 'member' : 'agent';
        this.WinLoseList = { ...this.ReportInstance[this.type] };
        this.calPagination({
          instance: 'WinLoseList',
          dataKey: this.dataKey,
        });
      } else {
        this.totalLog = 0;
        this.summaryLog = 0;
      }
    // } else if (this.isMember && stageForFetchBetTrans !== 'both') {
    } else if (this.isMember && this.durationTime) {
    // if (this.isMember) {
      this.startdate = this.$moment(this.Period.start.date).format('DD-MM-YYYY');
      this.Period.start.date = this.$moment(this.Period.start.date).toDate();

      this.enddate = this.$moment(this.Period.end.date).format('DD-MM-YYYY');
      this.Period.end.date = this.$moment(this.Period.end.date).toDate();
      const criteriaLog = {
        ...this.Criteria, ...this.Period , time: this.durationTime, isElastic: true,
      };
      if (this.$moment(this.Period.start.date).format('YYYYMMDD') < 20210513) {
        this.Criteria.isElastic = false;
        criteria.isElastic = false;
      }
      res = await this.ReportInstance.FetchWinLoseLog(criteriaLog);
      if (typeof res === 'object' && res.users && res.users.length) {
        this.isRangeDate = true;
        if (['SUPERADMIN', 'ADMIN'].includes(this.AuthInstance.user.role)) {
          this.TableHeadLog = [...WinLoseData.TableHeadLog];
          this.TableHeadLog[1] = [...WinLoseData.TableHeadLog[1]];
        } else {
          const filterOutstandingOut = [...WinLoseData.TableHeadLog[0]].filter((header: any) => header.displayName !== 'Outstanding');
          this.TableHeadLog = [filterOutstandingOut, [...WinLoseData.TableHeadLog[1]]];
        }
        const { summaryWinlose, users, count } = this.ReportInstance.dataWinLoseLog;
        users[0].each.forEach((val, idx) => {
          this.TableHeadLog[1].push({
            displayName: idx === users[0].each.length - 1
              ? 'report.winloseSimple.datatable.company'
              : 'report.winloseSimple.datatable.agent',
            attr: {
              class: 'text-right',
              style: 'top:32px;',
            },
            index: idx === users[0].each.length - 1
              ? 0
              : users[0].each.length - 1 - idx,
          });
        });
        this.detailFooterCol = users[0].each.length + 2;
        this.totalLog = !count ? users.length : count;
        this.summaryLog = summaryWinlose;
      } else {
        this.totalLog = 0;
        this.summaryLog = 0;
      }
    } else {
      res = await this.ReportInstance.FetchNewWinLoseV2(criteria);
      if (res.code) {
        this.checkError(res);
        this.resultData.users = [];
        this.PaginationDetail.amount = 1;
        this.PaginationDetail.current = 1;
        return false;
      }
      this.GeneralInstance.toggleLoading(false);
      if (['COMPANY', 'SUPERADMIN'].includes(this.Criteria.role) || ['COMPANY', 'SUPERADMIN', 'SUBCOMPANY'].includes(this.AuthInstance.user.role)) {
        this.FilteredTableHeadMember[0] = [...WinLoseData.TableHeadMember[0]]
          .filter((item: any) => !item.isCompanyHidden);
      } else {
        this.FilteredTableHeadMember[0] = [...WinLoseData.TableHeadMember[0]]
          .filter((item: any) => !item.isFirstLevel);
        this.FilteredTableHeadMember[1] = [...WinLoseData.TableHeadMember[1]];
      }
      const { turnover, raw: { winlose } } = this.ReportInstance.dataWinLose.footerSummary;
      this.houseEdge = (winlose / turnover) * -100;
    }
    this.type = this.isMember ? 'dataWinLoseLog' : 'dataWinLose';
    this.mode = this.isMember ? 'member' : 'agent';
    this.WinLoseList = { ...this.ReportInstance[this.type] };
    if (res.code) {
      this.checkError(res);
    } else {
      this.BreadcrumbList = [
        ...this.BreadcrumbDefault,
        ...this.WinLoseList.breadcrumb.map((v) => ({
          ...v,
          userId: v._id,
        })),
      ];
      this.calPagination({
        instance: 'WinLoseList',
        dataKey: this.dataKey,
      });
      this.resultData = { ...this.WinLoseList };
      this.resultData[this.dataKey] = res.users;
    }
    this.componentKey += 1;
    this.GeneralInstance.toggleLoading(false);
  }

  async fetchResult(params) {
    const {
      gameName,
      products,
      getReport,
      tranId,
      timestamp,
      categories,
      user: { username },
    } = params;

    const reqParams = {
      dateTime: this.$moment(timestamp).format('YYYY-MM-DD HH:MM:ss'),
      report: getReport,
      gameName,
      products: categories === 'BONUS' ? 'ANGPOW' : products,
      tranId: products === 'EVOPLAY' ? getReport ? getReport.round_id : {} : tranId,
      username,
      categories,
      language: this.$i18n.locale,
      roundId: getReport ? getReport.round_id : {},
    };
    const reqParamsMH = {
      language: this.$i18n.locale,
      roundId: getReport ? getReport.round_id : {},
      prefix: 'MONSTERHUNTER',
    };
    if (products === 'AMBSLOT' && categories === 'ARCADE') {
      const res = await this.ReportInstance.FetchResultBackend({
        username,
        tranId,
      });
      if (res.code) this.checkError(res);
      if (res.data.url) window.open(res.data.url, '_blank', 'top=0,left=0,scrollbars=no');
    } else if (products === 'AMBSLOT' && ['FISHING', 'SLOT'].includes(categories)) {
      const res = await this.ReportInstance.FetchResultMH(reqParamsMH);
      if (res.code) this.checkError(res);
      if (res.url) window.open(res.url, '_blank', `top=0,left=0,scrollbars=no,${['SLOT'].includes(categories) && 'height=730,width=410'}`);
    } else {
      const { data, status } = await this.ReportInstance.FetchResult(reqParams);
      if (status.code) {
        this.failResult = true;
        this.checkError(status);
      }
      if (data) {
        const strWindowFeatures = `top=0,left=0,scrollbars=no,${!['GAMATRON', 'MANNAPLAY', 'DS', 'EVOPLAY'].includes(products) && 'height=730,width=410'}`;
        if (products === 'DS') {
          window.open(data.url, '_blank');
        } else if (products === 'PG') {
          const windowOptions = 'top=0,left=0,scrollbars=no,height=734,width=414';
          if (getReport.roundId) {
            window.open(data.url, '_blank', windowOptions);
          } else {
            const _window = window.open('', '_blank', windowOptions);
            _window.document.write(data);
            _window.document.close();
          }
        } else window.open(data.url, 'gameResult', strWindowFeatures);
      }
    }
  }

  async fetchGame() {
    const res = await this.GameInstance.FetchGame();
    if (res.code) {
      this.checkError(res);
    } else {
      await this.mapGameInput();
    }
  }

  @Watch('$i18n.locale')
  onLanguagChange() {
    if (this.$i18n.locale) {
      this.mapGameInput();
    }
  }

  async mapGameInput() {
    const games = await this.GameInstance.game;
    Object.keys(games).forEach((key) => {
      this.dropdownCriteria[key][`${key}List`] = games[key];
    });
    this.dropdownCriteria.products.productsList
      .sort((a: any, b: any) => a.provider.localeCompare(b.provider));
    this.dropdownCriteria.products.componentKeys += 1;
    this.dropdownCriteria.categories.componentKeys += 1;
    this.dropdownCriteria.games.componentKeys += 1;
  }

  onSubmit() {
    this.PaginationDetail.current = 1;
    this.Criteria.page = 1;
    this.durationTime = '';
    this.fetchWinLose();
  }

  onReset() {
    this.initial();
    this.durationTime = '';
    this.fetchWinLose();
  }

  handleSearch() {
    this.isMember = this.AuthInstance.user.role === 'ADMIN';
    this.Criteria.username = this.LoginName
      ? this.LoginName
      : this.AuthInstance.user.username;
  }

  handleFetchWinloseAgent(username, role, source, id) {
    this.durationTime = '';
    this.beforeFetch(username, role, source, id, this.durationTime);
  }

  handleTimeRange(username, role, source, id, durationTime) {
    this.beforeFetch(username, role, source, id, durationTime);
  }

  handleGame() {
    this.fetchWinLose();
  }

  handleBreadcrumb({
    username, role, source, userId,
  }) {
    this.durationTime = '';
    const IS_PRESS_BREADCRMN = role === 'MEMBER';
    this.beforeFetch(username, role, source, userId, this.durationTime, IS_PRESS_BREADCRMN);
  }

  beforeFetch(username, role, source, id, durationTime, isPressFromBreadcrumn = false) {
    this.isMember = role === 'MEMBER';
    this.LoginName = '';
    this.Criteria.username = username;
    this.Criteria.source = source;
    this.Criteria.role = role;
    this.Criteria.userId = id;
    this.PaginationDetail.current = 1;
    this.Criteria.page = 1;
    this.durationTime = durationTime;
    this.fetchWinLose(isPressFromBreadcrumn);
  }
}
